import { Modal } from "@stormwater-software/lib-ui";
import React, { useState } from "react";

export interface IDeleteConfirmModalProps {
  show: boolean;
  title: string;
  message: string;
  onClose: () => void;
  onConfirm: () => void | Promise<unknown>;
}

/**
 * Shared "type-to-confirm" delete modal. The Delete button stays disabled
 * until the user checks "Yes, I understand".
 */
const DeleteConfirmModal: React.FC<IDeleteConfirmModalProps> = ({
  show,
  title,
  message,
  onClose,
  onConfirm,
}) => {
  const [confirmed, setConfirmed] = useState<boolean>(false);

  const handleClose = () => {
    setConfirmed(false);
    onClose();
  };

  return (
    <Modal show={show} title={title} handleClose={handleClose} hideButtons={true}>
      <p>{message}</p>
      <div className="removal-confirmation">
        <input
          type="checkbox"
          id="proceed"
          name="proceed"
          onClick={() => setConfirmed(value => !value)}
        />
        <label>Yes, I understand</label>
      </div>
      <div className="buttons">
        <button className="reversed outline" type="button" onClick={handleClose}>
          Cancel
        </button>
        &nbsp;
        <button
          className="warn reversed"
          disabled={!confirmed}
          onClick={() => onConfirm()}
        >
          Delete
        </button>
      </div>
    </Modal>
  );
};

export default DeleteConfirmModal;
